import type { BuilderType } from '@shared/utils/api/configs/rtkBaseQueryDemo';
import { GET_PAYMENTS_PAID_BILLS_HISTORY_URL } from '@shared/utils/api/configs/URL';
import { hasCcdpPartialSuccess, hasCcdpSuccess } from '@shared/utils/api/handlers/interpretCcdpCode/interpretCcdpCode';
import type { GenericApiResponse } from '@shared/utils/api/types';

import type { GetHistoryBillsPayload, GetHistoryBillsResult, HistoryBill } from '../types/getHistoryBills.types';

export const PAYMENT_HISTORY = 'PaymentHistory';

export const getHistoryBills = (builder: BuilderType) =>
  builder.query<HistoryBill[], GetHistoryBillsPayload>({
    keepUnusedDataFor: 0,
    providesTags: [PAYMENT_HISTORY],
    query: (data) => ({
      data,
      method: 'POST',
      url: GET_PAYMENTS_PAID_BILLS_HISTORY_URL,
    }),
    transformResponse: (response: GenericApiResponse<GetHistoryBillsResult>) => {
      if (hasCcdpSuccess(response) || hasCcdpPartialSuccess(response)) {
        return response.Result.PaidBills;
      }
      throw {
        code: response.Code,
        message: response.Message,
      };
    },
  });
